import idsTokensDefault from '../../utils/tokens/idsTokens';

export const classes = (idsTokens = idsTokensDefault) => ({
  line: {
    borderRadius: idsTokens.stepper.default.radius.pathStart,
  },
  vertical: {
    marginTop: -11,
    marginBottom: 1,
    '& .MuiStepConnector-line': {
      backgroundColor: 'transparent',
    },
  },
  lineVertical: {
    marginLeft: 3,
    backgroundColor: idsTokens.stepper.default.color.incomplete.path.enabled,
    borderLeftStyle: 'none',
    width: 2,
    minHeight: 21,
  },
  horizontal: {
    borderTopColor: 'transparent',
  },
  lineHorizontal: {
    borderTopColor: idsTokens.stepper.default.color.incomplete.path.enabled,
    borderTopStyle: 'solid',
    borderTopWidth: 2,
  },
  root: {
    '&.Mui-active, &.Mui-completed': {
      '&.MuiStepConnector-horizontal > .MuiStepConnector-line': {
        borderColor: idsTokens.stepper.default.color.completed.path.enabled,
      },
      '&.MuiStepConnector-vertical > .MuiStepConnector-line': {
        backgroundColor: 'transparent',
      },
    },
    pointerEvents: 'none',
    left: 'calc(-50% + 15px)',
    right: 'calc(50% + 21px)',
  },
  alternativeLabel: {
    top: 16,
  },
});
